import { useMemo } from "react";
import RawSharedBasic from "./RawSharedBasic";
import { ModalProp, TMSOrderVCType } from "@/types";

const InstaOrderRequestDataInfo: ModalProp[] = [
  {
    key: "orderType",
    label: "Order Type",
  },
  {
    key: "poNo",
    label: "PO No",
  },
  {
    key: "platform",
    label: "Platform",
  },
  {
    key: "warehouseCode",
    label: "Warehouse Code",
  },
  {
    key: "customerNumber",
    label: "Customer Number",
  },
  {
    key: "shippingMethod",
    label: "Shipping Method",
  },
  {
    key: "packageType",
    label: "Package Type",
  },
  {
    key: "requireSSCCNo",
    label: "SSCC Required",
    convertor: (value: string) => (value ? "Yes" : "No"),
  },
];

function labelExtra(platform: TMSOrderVCType): ModalProp[] {
  if (platform === TMSOrderVCType.NEXCOM) {
    return [
      {
        key: "labelExtra.nexcomMarkForNo",
        label: "Nexcom Mark For",
      },
    ] as ModalProp[];
  } else if (platform === TMSOrderVCType.AAFES) {
    return [
      {
        key: "labelExtra.aafesFacilityNo",
        label: "AAFES Facility No.",
      },
    ] as ModalProp[];
  } else if (platform === TMSOrderVCType.BestBuy) {
    return [
      {
        key: "labelExtra.bestbuyStoreNumber",
        label: "BBY Store No.",
      },
      {
        key: "labelExtra.bestbuyASNNo",
        label: "BBY ASN No.",
      },
    ] as ModalProp[];
  } else if (platform === TMSOrderVCType.Target) {
    return [];
  } else if (platform === TMSOrderVCType.Amazon) {
    return [] as ModalProp[];
  }
  return [];
}

interface InstaOrderRequestRawProps {
  rawData: Record<string, unknown>;
  className?: string;
  column?: number;
  labelStyle?: React.CSSProperties;
  contentStyle?: React.CSSProperties;
}

export const InstaOrderRequestRaw = (props: InstaOrderRequestRawProps) => {
  const { rawData, className, column, labelStyle, contentStyle } = props;
  const dataProps = useMemo(() => {
    const props = labelExtra(rawData.platform as TMSOrderVCType);
    return [...InstaOrderRequestDataInfo, ...props];
  }, [rawData]);
  return (
    <RawSharedBasic
      rawData={rawData}
      dataProps={dataProps}
      className={className}
      column={column}
      labelStyle={labelStyle}
      contentStyle={contentStyle}
    />
  );
};
